import { createApp } from "vue";
import { createStore } from "vuex";
import SizeQuantityControl from "components/jiffy/vue-cart/LineItem/MadeProductUpsert/SizeQuantityControl.vue";
import ProductDetailsV2 from "components/jiffy/vue-cart/LineItem/MadeProductUpsert/ProductDetailsV2.vue";
import ProductDetails from "components/jiffy/vue-cart/LineItem/MadeProductUpsert/ProductDetails.vue";
import ColorPicker from "components/jiffy/vue-cart/LineItem/MadeProductUpsert/ColorPicker.vue";
import UseSvg from "common/vue/components/UseSvg.vue";
import i18n from "components/jiffy/vue-cart/vue-i18n";
import initContinueShoppingModal from "components/jiffy/continue-shopping-modal/continue-shopping-modal";
import initJiffyServicesPreview from "components/jiffy/jiffy-services-preview/jiffy-services-preview";

import createStoreModule from "./store";
import MadeReorderModal from "./MadeReorderModal.vue";

let continueShoppingModalInitialized = false;

const $getMadeReorderModalContainer = () => document.getElementById("made-reorder-modal-container");

const initMadeReorder = async () => {
  const container = $getMadeReorderModalContainer();

  if (!container) {
    return null;
  }

  if (!continueShoppingModalInitialized) {
    try {
      await initContinueShoppingModal();
      initJiffyServicesPreview("#jiffy-services-preview-atc");
      continueShoppingModalInitialized = true;
    } catch (error) {
      window.Honeybadger?.notify(
        "Failed to initialize continue shopping modal on made reorder modal",
        {
          params: {
            error: JSON.stringify(error)
          }
        }
      );
    }
  }

  const store = createStore(createStoreModule());

  const app = createApp(MadeReorderModal);

  app.component("UseSvg", UseSvg);
  app.component("SizeQuantityControl", SizeQuantityControl);
  app.component("ProductDetailsV2", ProductDetailsV2);
  app.component("ProductDetails", ProductDetails);
  app.component("ColorPicker", ColorPicker);

  app.use(store);
  app.use(i18n);
  const instance = app.mount(container);

  return instance;
};

export default initMadeReorder;
